<template>
    <div class="modal fade" tabindex="-1" aria-label="Auggie Help" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Auggie Help</h5>
                    <spin-x aria-label="Close" @click="cancelClicked" :spinning="loading"></spin-x>
                </div>

                <div class="modal-body">
                    <loading :loading="initializing()" />
                    <div class="row">
                        <div class="col-6">
                            <div class="qrcode">
                                <qrcode :value="url" :size="200"></qrcode>
                            </div>
                        </div>
                        <div class="col-6 qrcode-text">
                            <div>
                                Please scan this QR code using your mobile device to view Auggie Help information.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="special">
                        <a-button v-if="!isPrototype()" class="me-5" @click.prevent="assistanceClicked" :disabled="loading">Enable Remote Assistance</a-button>
                        <a-button class="me-5" @click.prevent="restartClicked" :disabled="loading">Restart Device</a-button>
                    </div>
                    <div class="assistance">
                        For Assistance please call (904) 990-1122
                    </div>
                    <spin-button class="btn-secondary" @click="cancelClicked" :spinning="loading">Close</spin-button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scode lang="scss">
    .qrcode {
        margin:auto;
        background: white;
        text-align: center;
        width:200px;
        height:200px;
    }
    .qrcode-text {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.5rem;
    }
    .modal-footer {
        position: relative;
        .assistance {
            position: absolute;
            top: 0.3em;
            left: 1em;
            color: orangered;
            font-size: 30px;
            font-weight: bold;
        }
        .special {
            position: absolute;
            left: 1ch;
            bottom: .5ch;
            font-size: 18px;
        }
    }

</style>

<script lang="ts">

import { defineComponent } from "vue";
import ModalBase from "@/shared/components/common/ModalBase";
import Qrcode from "@/components/Qrcode.vue";
import { AUGGIEAVAILABLE } from "@/main";
import Toast from "@/shared/support/Toast";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { CalibrationEvent } from "@/shared/enums/CalibrationEvent";
import { Global } from "@/support/GlobalData";
import { confirmOk } from "@/shared/components/common/AlertDialog.vue";

// Static reference stored outside the component
let helpModalInstance: { hide: () => void } | null = null;

export default defineComponent({
    name: "HelpModal",
    mixins: [ModalBase],
    components: {
        Qrcode,
    },
    data() {
        return {
            url: "https://airprodiagnostics.com/auggie-frequently-asked-questions/",
        };
    },
    methods: {
        isPrototype(): boolean {
            return Global.IsPrototype();
        },
        show(): void {
            killHelpModal();
            this.showModal();
            this.initialized();
            helpModalInstance = { hide: () => this.hide() };
        },
        hide(): void {
            this.hideModal();
            helpModalInstance = null;
        },
        assistanceClicked(): void {
            this.loading = true;
            if (AUGGIEAVAILABLE) {
                if (Auggie.TeamViewer.On()) {
                    Toast.success("Remote Assistance has been enabled.");
                    CalibrationEventSupport.sendEventTvStarted(CalibrationEvent.TeamViewerStarted, Global.DeviceName, null);
                } else
                    Toast.warning("Remote Assistance could not be enabled.");
            } else {
                Toast.warning("Remote Assistance not available on development system.");
            }
            this.loading = false;
            this.hide();
        },
        restartClicked(): void {
            if (AUGGIEAVAILABLE) {
                Auggie.System.Restart();
            } else {
                confirmOk("Restart Device clicked - not available on development system");
            }
        },
        cancelClicked(): void {
            this.hide();
        },
    },
});

export function killHelpModal(): void {
    if (helpModalInstance) {
        helpModalInstance.hide();
        helpModalInstance = null;
    }
}

</script>
